import { PolicyRouteOption } from './policy';

/** Local display names never replace routing identity. */
export function providerLabel(route: PolicyRouteOption) {
  return [route.access_display_name, route.display_name, route.access_code].filter(Boolean).join(' · ');
}
